var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"readonly-text-field"},[_c('fields-group',{attrs:{"label":_vm.label}},[_c('div',{staticClass:"readonly-text-field_text"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }